var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
var SvgSovosLogo = function SvgSovosLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SovosLogo_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "SovosLogo_svg__b",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0v24h24V0Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#SovosLogo_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 0H0v24h24V0Zm-2.1 2.175H2.175V21.9H21.9V2.175Zm-9.675 5.25c-1.95 0-2.775.75-2.775 1.725 0 1.18 1.418 1.515 3.02 1.893 2.066.488 4.438 1.048 4.48 3.582 0 2.025-1.65 3.75-5.1 3.75-1.575 0-3.075-.375-4.2-.975v-2.325c1.05.825 2.625 1.425 4.2 1.425 1.95 0 2.775-.75 2.775-1.65 0-1.162-1.39-1.49-2.973-1.865-2.095-.494-4.527-1.07-4.527-3.76 0-2.025 1.65-3.75 5.1-3.75 1.2 0 2.475.225 3.45.675V8.4a6.708 6.708 0 0 0-3.45-.975Z",
    fill: "#072448"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SovosLogo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSovosLogo;